module.exports = __webpack_public_path__ + "img/lock.e63650ac.svg";